// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fpjv","top":"styles_top__3gyCd","left":"styles_left__2Rdfu","description":"styles_description__pzmuj"};